if (!customElements.get('kp-review-form')) {
  let tallyPromise;
  function loadTally() {
    if (window.Tally?.openPopup) return Promise.resolve();
    if (tallyPromise) return tallyPromise;
    tallyPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      script.dataset.kpTallyScript = '';
      script.onload = () => resolve();
      script.onerror = () => { script.remove(); tallyPromise = undefined; reject(new Error('Form unavailable')); };
      document.head.append(script);
    });
    return tallyPromise;
  }
  customElements.define('kp-review-form', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.trigger = this.querySelector('[data-review-open]');
      this.trigger?.addEventListener('click', async event => {
        event.preventDefault();
        if (this.loading) return;
        this.loading = true;
        this.trigger.setAttribute('aria-busy', 'true');
        try {
          await loadTally();
          if (signal.aborted) return;
          this.querySelector('[data-review-fallback]').hidden = true;
          window.Tally.openPopup(this.dataset.formId, {
            layout: 'modal', width: 500, overlay: true,
            emoji: { text: '✍️', animation: 'wave' },
            hiddenFields: { product_id: this.dataset.productId, product_title: this.dataset.productTitle, product_url: this.dataset.productUrl },
            onOpen: () => { this.active = true; this.trigger.setAttribute('aria-expanded', 'true'); },
            onClose: () => { this.active = false; this.trigger.setAttribute('aria-expanded', 'false'); if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true }); }
          });
        } catch {
          if (!signal.aborted) this.querySelector('[data-review-fallback]').hidden = false;
        } finally {
          this.loading = false;
          this.trigger.removeAttribute('aria-busy');
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.active) window.Tally?.closePopup(this.dataset.formId);
    }
  });
}
